import { toast } from 'react-hot-toast';

export const initFilterling = (data: string) => {
  // test
  // document.body.innerHTML = `initFiltering 함수 실행`;
  // 여기 아래에 코드 작성
  toast(data.toString());
};
